import "./components/swiper";
import "./components/modal";
import "./components/observer";
import "./components/different";
import "./components/burger";
import "./components/dynamic-adapt";
import "./components/accordion";
